import axios from "@/api/axiosAuthRequired.js"

const INSTAPRO_API_URL = process.env.INSTAPRO_API_URL

export const getAvailableQuestionSets = async (gameId, type) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/questions`
    const params = {
      params: {
        type,
        game_id: gameId,
      },
    }
    const res = await axios.get(url, params)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const putAnswersToQuestions = async (
  questionSet,
  body,
  instaProAccessToken
) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/user/questions/answers/${questionSet}`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getConversionOffer = async instaProAccessToken => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/user/conversion-offering-page`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getGameSpecificPersonas = async (gameId, instaProAccessToken) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/user/game-specific-classifications/${gameId}`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    if (error.response.status === 404) {
      console.log("You have no persona for this game")
    } else {
      console.error(error)
    }
    return null
  }
}

export const getUserLatestAnswers = async (
  questionSet,
  instaProAccessToken
) => {
  try {
    const url = `${INSTAPRO_API_URL}api/v1/user/latest-answers?question_set_id=${questionSet}`
    const config = {
      headers: {
        Authorization: "Bearer " + instaProAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/api/onboarding.js